import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import TimeConstants from '../../constants/TimeConstants';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../../hooks/useRequestConfig';

export const useGetMaintenanceTasks = (propertyId = '', queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/summary/maintenance`,
      requestConfig,
      config: {
        params: { propertyId },
      },
    });

  return useQuery({
    queryKey: ['getMaintenanceTasks', propertyId],
    queryFn,
    ...queryOptions,
    enabled: Boolean(propertyId),
    staleTime: TimeConstants.SECONDS_10,
  });
};
